import React from 'react';

import css from './ModalTribeInvitation.module.css';
import { H3, CircleCustomIcon, Modal, PrimaryButton, AvatarSmall } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import { extractCountryCodeFromAddress, getCountryFlagImage } from '../../util/data';

const ModalTribeInvitation = ({
  onManageDisableScrolling,
  openModal,
  handleCloseModal,
  endorsements,
  history,
  routeConfiguration,
  onInteractedWithModal,
  currentUser,
}) => {
  if (!endorsements.length) return null;

  const user = endorsements[0];
  const {
    attributes: {
      profile: { publicData, displayName },
    },
  } = user ?? {};

  const countryCode = extractCountryCodeFromAddress(publicData?.location?.address);

  const handleRedirectUser = () => {
    onInteractedWithModal();
    history.push(createResourceLocatorString('SearchTribePage', routeConfiguration, {}, {}));
  };

  const { isProfileCompleted } = currentUser.attributes.profile.publicData ?? {};
  const id = isProfileCompleted ? 'Topbar.endorseSubmit' : 'Topbar.endorseSubmitWithoutOnboard';

  const country = publicData?.location?.address?.split(',').at(-1);

  return (
    <Modal
      id="ModalTribeInvitation"
      containerClassName={css.modalContainerClassName}
      isOpen={openModal}
      onClose={handleCloseModal}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
      closeButtonMessage=""
    >
      <div>
        <H3 className={css.title}>
          <FormattedMessage id="Topbar.modalTribeInvitationTitle" />
        </H3>

        <div className={css.userInfo}>
          <AvatarSmall className={css.avatar} user={user} disableProfileLink />
          <span className={css.userFullName}>{displayName}</span>
          <span className={css.countryFlag}>
            {!getCountryFlagImage(countryCode)?.includes('null') && (
              <img src={getCountryFlagImage(countryCode)} alt="flag" />
            )}
          </span>
          <span className={css.location}>{country}</span>
        </div>

        <p className={css.description}>
          <FormattedMessage id="Topbar.modalTribeInvitationDescription" />
        </p>

        <div className={css.buttonsWrapper}>
          <PrimaryButton
            className={css.submitNextButton}
            type="button"
            onClick={handleRedirectUser}
          >
            <FormattedMessage id={id} />
            <div className={css.verticalDivider} />
            <CircleCustomIcon />
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTribeInvitation;
